import request from '@/http/request'
import {
  paperAnalysisTaskList,
  paperAnalysisCreateTask,
  paperAnalysisModifyTask,
  paperAnalysisDeleteTask,
  paperAnalysisStartTask,
  paperAnalysisStopTask,
  paperAnalysisTaskProgress,
  paperAnalysisTaskResult,
  paperAnalysisTaskDetail,
  paperAnalysisCourseDetail,
  paperAnalysisFixedPaperCharts,
  paperAnalysisRandomPaperCharts,
  paperAnalysisQuestionList,
  paperAnalysisBatchOptions,
  paperAnalysisCourseOptions,
  paperAnalysisExportExcel,
  paperAnalysisExportPdf
} from '@/http/api'

export const getTaskListAPI = (data) => {
  return request({ url: paperAnalysisTaskList, data })
}

export const createTaskAPI = (data) => {
  return request({ url: paperAnalysisCreateTask, data })
}

export const modifyTaskAPI = (data) => {
  return request({ url: paperAnalysisModifyTask, data })
}

export const deleteTaskAPI = (data) => {
  return request({ url: paperAnalysisDeleteTask, data })
}

export const startTaskAPI = (data) => {
  return request({ url: paperAnalysisStartTask, data })
}

export const stopTaskAPI = (data) => {
  return request({ url: paperAnalysisStopTask, data })
}

export const getTaskProgressAPI = (data) => {
  return request({ url: paperAnalysisTaskProgress, data })
}

export const getTaskResultAPI = (data) => {
  return request({ url: paperAnalysisTaskResult, data })
}

export const getTaskDetailAPI = (data) => {
  return request({ url: paperAnalysisTaskDetail, data })
}

export const getCourseDetailAPI = (data) => {
  return request({ url: paperAnalysisCourseDetail, data })
}

export const getFixedPaperChartsAPI = (data) => {
  return request({ url: paperAnalysisFixedPaperCharts, data })
}

export const getRandomPaperChartsAPI = (data) => {
  return request({ url: paperAnalysisRandomPaperCharts, data })
}

export const getQuestionListAPI = (data) => {
  return request({ url: paperAnalysisQuestionList, data })
}

export const getBatchOptionsAPI = (data) => {
  return request({ url: paperAnalysisBatchOptions, data })
}

export const getCourseOptionsAPI = (data) => {
  return request({ url: paperAnalysisCourseOptions, data })
}

export const exportExcelAPI = (data) => {
  return request({ url: paperAnalysisExportExcel, data })
}

export const exportPdfAPI = (data) => {
  return request({ url: paperAnalysisExportPdf, data })
}
